// Uso este baile de tipos para evitar acoplarme a la estructura completa de los DTOs CustomerOfferDTO y CustomerForEditionDTO.
// Eso me permite escribir los tests de forma mucho más simple porque me ahorra construir objetos excesivamente completos. No
// tengo muy claro que sea una buena idea, pero lo dejo así para probar. Si vemos que esto es una tontería, lo cambiamos al
// sistema estándar de construir objetos con builders en los tests

// Cualquier cosa que tenga un Id me sirve como oferta
type OfferLike = { Id: number };
// Lo que estoy editando (en realidad un CustomerOfferDTO), contiene un OfferLike dentro
type CustomerOfferInEdition = { Offer: Nullable<OfferLike> };
// La entidad que lo contiene, incluye un array de ExistingOffers (en realidad, OfferInListDTO) y un array de Offers con 
// las que se le han asignado (en realidad, CustomerOfferDTO)
type CustomerInEdition<T extends OfferLike> = {
	ExistingOffers: T[];
	Offers: CustomerOfferInEdition[];
};

export function getAvailableOffers<T extends OfferLike>(customerOfferToEdit: CustomerOfferInEdition, customer: CustomerInEdition<T>): T[] {
	// Necesito protegerme porque el tipo viene de un DTO de C# donde no se marcan las referencias como nullables, pero 
	// al crear un nuevo customerOffer todavía no tiene asignada la oferta
	const customerOfferToEditId = customerOfferToEdit.Offer ? customerOfferToEdit.Offer.Id : 0;

	const isOfferInEdition = (offer: OfferLike) => offer.Id === customerOfferToEditId;
	const isAlreadyAssigned = (offer: OfferLike) => customer.Offers.some(o => o.Offer && o.Offer.Id === offer.Id);
	return customer.ExistingOffers.filter(x => isOfferInEdition(x) || !isAlreadyAssigned(x));
}

